import { FC, Fragment } from "react"

import { PageTemplate } from "../../components/pageTemplate/PageTemplate"
import { SidebarPageContent } from "../../components/SidebarPageContent"
import { routeMap } from "../../components/generic/navbar/routeMap"
import { PageId } from "../../common/pageId"

export const Cookies: FC = () => {
  return (
    <PageTemplate
      pageTitle="Cookies"
      pageContentClassName="info-page-container"
    >
      <SidebarPageContent
        route={routeMap[PageId.Cookies]}
        sidebarItems={[
          {
            id: "WhatAreCookies",
            header: "What are Cookies",
            body: (
              <p>
                Cookies are small text files stored in your computer or mobile
                phone’s internet browser (e.g Internet Explorer, Chrome,
                Safari). They are usually used by websites to improve services
                for you, to find out more information about the popularity of a
                website, and for delivering more relevant advertising.
              </p>
            )
          },
          {
            id: "howDoesOCSUseCookies",
            header: "How does OCS use Cookies?",
            body: (
              <Fragment>
                <p>
                  OCS uses a cookie to register the user session and user ID.
                  OCS deletes the session cookie when the user logs out, the
                  session times out, or the browser is closed. OCS uses no other
                  cookies, in particular no tracking cookies.
                </p>
                <p>
                  OCS uses browser local storage to save user preferences and
                  selections within and between OCS sessions. This is stored
                  with the user ID as key and survives closing and reopening the
                  browser. We thus recommend not using a public browser for
                  accessing the OCS site.
                </p>
              </Fragment>
            )
          },
          {
            id: "CanIUseOCSWithoutCookies",
            header: "Can I use OCS without Cookies?",
            body: <p>No, the session cookie is necessary for OCS to work.</p>
          },
          {
            id: "WhereCanIReadMoreInfo",
            header: "Where can I read more information?",
            body: (
              <p>
                You can read more information by visiting{" "}
                <a
                  href="https://www.allaboutcookies.org/"
                  target="_blank"
                  rel="noreferrer"
                >
                  All About Cookies
                </a>
                .
              </p>
            )
          }
        ]}
      />
    </PageTemplate>
  )
}

